import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

// Action
import { 
    setPOSearchFields
} from '../js/actions/index';

// Bootstrap
import { Col, Row, Button, Accordion, Form, Table, Tab, Tabs, OverlayTrigger, Popover } from 'react-bootstrap';
import { 
    Shop,
    Truck,
    Check2Circle,
    ExclamationCircle,
    ExclamationTriangle
 } from 'react-bootstrap-icons';

import moment from 'moment';

// Components
import ContainerComponent from '../components/ContainerComponent';
import FormDropDownComponent from '../components/Form/DropDownComponent';
import DateSingleComponent from '../components/Form/DateSingleComponent';
import NoResultsComponent from '../components/NoResultsComponent';
import SearchListComponent from '../components/Form/SearchListComponent';

// Services
import {
    getSupplierDeliveryLines, 
    getSupplierOperators, 
    getSupplierPurchaseOrderStorageDates, 
    postDeliveryLinesQualityAssurance,
    getDeliveryLinesQualityAssurance
} from '../services/Supplier';
import {getBranchByAllDeliveryLine} from '../services/Branch';
import {getPOHistoryListRestuarant} from '../services/PurchaseOrder';

// Constants
import {FAIL, NO_USER_FOUND, FAILED_AUTHENTICATE_TOKEN} from '../constants/ApiResult';
//import { props } from 'bluebird';
//import AlertErrorComponent from '../components/AlertErrorComponent';
//import AlertSuccessComponent from '../components/AlertSuccessComponent';
//import AlertComponent from '../components/AlertComponent';

//const orientation = window.matchMedia("(max-width: 700px)").matches ? 'vertical' : 'horizontal';
/*
function AdvanceSettings() {
    return (
        <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
                <Accordion.Header>Advance Settings</Accordion.Header>
                <Accordion.Body>
                
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    )
}
*/
function TableAccordion({defaultActive, label, children}) {
    return (<Accordion defaultActiveKey={defaultActive ? 0 : false}>
        <Accordion.Item eventKey={0}>
            <Accordion.Header>
                {label}
            </Accordion.Header>
            <Accordion.Body>
                {children}
            </Accordion.Body>
        </Accordion.Item>
    </Accordion>); 
}

function PopOver({id, title, body, children=<></> }) {
    return (<OverlayTrigger 
    trigger={['hover', 'focus']} 
    placement="bottom"
    overlay={<Popover id={id}>
    <Popover.Header as="h3">{title}</Popover.Header>
    <Popover.Body>
      <p>
      {body}
      </p>
    </Popover.Body>
    </Popover>}
    rootClose={true}
    >
    {children}
    </OverlayTrigger>
    );
}

function TablePurchaseOrders({poHistoryList}) {
    return (
        <div className="mt-4">
            <Table striped bordered hover>
            <thead>
                <tr>
                <th>訂單號碼</th>
                <th>訂購日期</th>
                <th>送貨日期</th>
                <th>餐廳</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                <td>1</td>
                <td>Mark</td>
                <td>Otto</td>
                <td>@mdo</td>
                </tr>
                <tr>
                <td>2</td>
                <td>Jacob</td>
                <td>Thornton</td>
                <td>@fat</td>
                </tr>
            </tbody>
            </Table>
        </div>
    )
}

function SuccessIcon() {
    return <Check2Circle size={16} className="me-2 text-success" />
}

function ErrorIcon() {
    return <ExclamationCircle size={16} className="me-2 text-danger" />
}

function WarningIcon() {
    return <ExclamationTriangle size={16} className="me-2 text-warning" />
}

function branchesAllHavePo() {
    return true;
}

function Popup({id, title, body, children=<></> }) {
    return (
        <OverlayTrigger 
            trigger={['hover', 'focus']} 
            placement="bottom"
            overlay={<Popover id={`popover-${id}`}>
            <Popover.Header as="h3">{title}</Popover.Header>
            <Popover.Body>
                <p>
                {body}
                </p>
            </Popover.Body>
            </Popover>}
            rootClose={true}
        > 
        <span>{children}</span>
        </OverlayTrigger>
        );
}

function TableLogisticsPickDeliveryBranchPurchaseOrders({branchId = 0, purchaseOrders = [], history={}}) {
    return purchaseOrders.map( (po, index) => {
        if(po.BranchId === branchId) {
            return (
                <Button 
                    variant="link" 
                    type="button"
                    onClick={() => history.push('/purchase-order/'+po.POId)}
                    className={index > 1 ? "me-1" : ""}
                    key={po.POId}
                >
                    {po.OrderName}
                </Button>
            ) 
        } else return "";
    });
}

function TableLogisticsPickDelivery({
    deliveryLine = 0, 
    branches = [], 
    purchaseOrders = [], 
    history={}, 
    onClickNoPurchaseOrders=() => {},
    getDeliveryLineBranchQA=() => {}
    }) {
    let allHavePo = true;

    branches.forEach( (branch) => {
        // does this branch have a PO?
        if(purchaseOrders.findIndex( (po) => po.BranchId === branch.id ) === -1) {
            allHavePo = false;
        }
    });

    return (
        <div className="my-4">
            <Row>
                <Col>
                    <TableAccordion
                        defaultActive={false}
                        label={
                            branches.length
                            ?
                            <Row className="w-100">
                                <Col>
                                {
                                allHavePo
                                ?
                                <>
                                    <Popup
                                    id={deliveryLine}
                                    title="Success - Logistics - Pick and Delivery"
                                    body="All branches has at least one purchase order"
                                    >
                                    <SuccessIcon />
                                    </Popup>
                                    <span>{deliveryLine }</span>   
                                </>
                                :
                                <>
                                    <Popup
                                    id={deliveryLine}
                                    title="Warning - Logistics - Pick and Delivery"
                                    body="Not all branches has a purchase order"
                                    >
                                    <WarningIcon />                  
                                    </Popup>
                                    <span>{deliveryLine }</span> 
                                </>
                                }
                                </Col>
                                <Col className="text-end">
                                    <small># Branches: {branches.length} # PO: {purchaseOrders.length}</small>
                                </Col>
                            </Row>
                            :
                            <>
                            <Popup
                                id={deliveryLine}
                                title="Error - Logistics - Pick and Delivery"
                                body="Delivery line has no branches."
                            >
                                <ErrorIcon />
                            </Popup>
                            {deliveryLine}
                            </>
                        }
                    >
                        {!branches.length
                        ?
                        <>
                            No branches found
                        </>
                        :
                        <Table bordered hover>
                            <thead>
                                <tr>
                                    <th width="50%">Branch</th>
                                    <th width="50%">Purchase Orders</th>
                                </tr>
                            </thead>
                            <tbody>
                            {branches.map( (branch, index) => {
                                const QA = getDeliveryLineBranchQA(branch.id);
                                return (
                                <tr>
                                    <td width="50%">{branch.label}</td>
                                    <td width="50%">
                                    {purchaseOrders.filter( (row) => row.BranchId === branch.id ).length
                                    ?
                                    <TableLogisticsPickDeliveryBranchPurchaseOrders 
                                        branchId={branch.id}
                                        purchaseOrders={purchaseOrders}
                                        history={history}
                                    />
                                    :
                                        <>
                                            {QA
                                            ?
                                            <Button 
                                                variant="light"
                                                onClick={() => onClickNoPurchaseOrders(branch.id, QA.QAId)}
                                            >
                                                <SuccessIcon /> No Purchase Orders ({QA.username})
                                            </Button>
                                            :
                                            <Button 
                                                variant="light"
                                                onClick={() => onClickNoPurchaseOrders(branch.id, null)}
                                            >
                                                <WarningIcon /> No Purchase Orders?
                                            </Button>
                                            }
                                        </>
                                    }  
                                    </td>
                                </tr>
                                )
                            })}
                            </tbody>
                        </Table>
                        }
                    </TableAccordion>
                    {/*
                    <AlertSuccessComponent 
                        label="All branches have at least one PO"
                    />
                    */}
                </Col>
            </Row>
        </div> 
    )
}

export default function ReportsPurchaseOrders({history}) {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [serverError, setServerError] = useState(false);
    const [authError, setAuthError] = useState(false);
    const [alertErrorMessage, setAlertErrorMessage] = useState("");
    
    const [branchId, setBranchId] = useState(null);
    const [branchData, setBranchData] = useState([]);

    const [deliveryLineId, setDeliveryLineId] = useState(null);
    const [deliveryLineData, setDeliveryLineData] = useState([]);

    const [operatorId, setOperatorId] = useState(null);
    const [operatorData, setOperatorData] = useState([]);

    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState(moment());

    const [poHistoryList, setPOHistoryList] = useState([]);

    const [supplierPurchaseOrderStorageDatesData, setSupplierPurchaseOrderStorageDatesData] = useState([]);

    const [noResults, setNoResults] = useState(false);

    const [deliveryLinesQAList, setDeliveryLinesQAList] = useState([]);

    const auth = useSelector(state => state.auth);

    const poSearchFields = useSelector(state => state.poSearchFields);

    useEffect( () => {
        // do api call
        (async() => {
            try {

                let res = {};
                let data = [];
                let array = [];

                // <!-- START DELIVERY LINE

                res = await getSupplierDeliveryLines({
                    token:auth.token,
                    supplierId:auth.supplierId
                });
    
                data = res.data.data;
                handleAPIResponse(res.data.result);
    
                // transform
                array = data.map( (obj) => {
                    return {
                        id:obj.DeliveryId,
                        label:obj.Label
                    }
                });
    
                array.unshift({
                    id:0,
                    "label":"All Delivery Lines"
                });
    
                setDeliveryLineData(array);

                // END -->

                // <!-- START BRANCH

                res = await getBranchByAllDeliveryLine({
                    token:auth.token,
                    supplierId:auth.supplierId    
                });

                data = res.data.data;
                handleAPIResponse(res.data.result);

                // transform
                array = [];
                data.forEach( (obj) => {
                    if(array.findIndex( (row) => row.id === obj.BranchId ) === -1) {
                        array.push({
                            id:obj.BranchId,
                            label:`(${obj.branchCode}) ${obj.BranchName}`,
                            deliveryLine:obj.DeliveryLine,
                            searchText:`${obj.BranchName}${obj.branchCode}`
                        }); 
                    }
                });
    
                array.unshift({
                    id:0,
                    "label":"All Branches",
                    "deliveryLine":0,
                    "searchText":""
                });
    
                setBranchData(array);

                // END -->

                // <!-- START OPERATOR

                res = await getSupplierOperators({
                    token:auth.token,
                    supplierId:auth.supplierId    
                });

                data = res.data.data;
                handleAPIResponse(res.data.result);

                // transform
                array = data.map( (obj) => {
                    return {
                        id:obj.operatorID,
                        label:obj.username
                    }
                });
    
                array.unshift({
                    id:0,
                    "label":"All Operators"
                });
    
                setOperatorData(array);

                // END -->

                // <!-- START SUPPLIER PO STORAGE DATES

                res = await getSupplierPurchaseOrderStorageDates({
                    token:auth.token,
                    supplierId:auth.supplierId    
                });

                data = res.data.data;
                handleAPIResponse(res.data.result);
    
                setSupplierPurchaseOrderStorageDatesData(data);

                // END -->


    
            } catch (err) {
                handleServerErrorAPI(err);
            }

            // PO History List, Delivery Line QA
            getDeliveryLinesData();
            
        })();
    });

    useEffect( () => {
        onClickSearch();
    },[startDate]);

    function handleAPIResponse(result) {
        if (
            [FAIL].indexOf(
              result
            ) > -1
          ) {
            setLoading(false);
            setServerError(true);
        }

        if (
            [NO_USER_FOUND, FAILED_AUTHENTICATE_TOKEN].indexOf(
              result
            ) > -1
          ) {
            setLoading(false);
            setAuthError(true);
        }
    }

    function handleServerErrorAPI(err) {
        if (err) console.error(err);
        setLoading(false);
        setServerError(true);
      };

    function handleOnSubmit(e) {
        e.preventDefault();
    }

    function handleOnSelectBranch(branchId) {
        setBranchId(parseInt(branchId));
    }

    function getBranchData() {
        if(deliveryLineId) {
            return branchData.filter( (obj) => (obj.deliveryLine === deliveryLineId || obj.id === 0) );
        } else {
            return branchData;
        }
    }

    function handleOnSelectDeliveryLine(deliveryId) {
        setDeliveryLineId(parseInt(deliveryId));
        setBranchId(0);
    }

    function handleOnSelectOperator(operatorId) {
        setOperatorId(parseInt(operatorId));
    }

    function getOperatorName(operatorId) {
        let operator = operatorData.filter( (obj) => obj.id === operatorId )[0];
        if(operator) {
            return operator.label;
        }
        return "";
    }

    function handleDateSingleChange(start) {
        setStartDate(start);
        dispatch(setPOSearchFields({
            "field":"searchDate",
            "value":moment(start).format('YYYY-MM-DD')
        }));
    }

    function handleDateRangeChange(start, end) {
        setStartDate(start);
        setEndDate(end);
    }

    function searchIsDisabled() {
        if(!startDate || !endDate) {
            return true;
        }
        return false;
    }

    function onClickSearch() {
        setLoading(true);
        getDeliveryLinesData();
    }

    function handleClickNoPurchaseOrders(branchId, QAId) {
        let msg = "This branch has no purchase orders?";
        if(QAId) {
            msg = "This branch has purchase orders?";
        }
        const confirm = window.confirm(msg);
        if(confirm) {
            (async() => {
                try {

                    setLoading(true);

                    const res = await postDeliveryLinesQualityAssurance({
                        payload:{
                            supplierId:auth.supplierId,
                            branchId:branchId,
                            operatorId:auth.operatorId,
                            storageDate:moment(poSearchFields.searchDate).format('YYYY-MM-DD 00:00:00'),
                            state:1,
                            qaId:QAId
                        },
                        token:auth.token
                    });

                    getDeliveryLinesData({
                        getPOHistoryListRestuarant:false,
                        getDeliveryLinesQualityAssurance:true
                    });

                } catch (err) {
                    handleServerErrorAPI(err);
                }
            })();
        } else {
            // nothing happens
        }
    }

/*
Logistics - Pick and Delivery
*/

    function getDeliveryLineBranches(deliveryId) {
        if(branchId) {
            return branchData.filter( (row) => row.deliveryLine === deliveryId && row.id === branchId );
        } else {
            return branchData.filter( (row) => row.deliveryLine === deliveryId );
        }
    }

    function getDeliveryLinePurchaseOrders(deliveryId) {
        if(poHistoryList.length) {
            if(branchId && operatorId) {
                return poHistoryList.filter( (obj) => JSON.parse(obj.deliveryLine).id === deliveryId && obj.Operator === getOperatorName(operatorId) && obj.BranchId === branchId);
            } else if(branchId && !operatorId) {
                return poHistoryList.filter( (obj) => JSON.parse(obj.deliveryLine).id === deliveryId && obj.BranchId === branchId);
            } else if(!branchId && operatorId) {
                return poHistoryList.filter( (obj) => JSON.parse(obj.deliveryLine).id === deliveryId && obj.Operator === getOperatorName(operatorId));
            } else {
                return poHistoryList.filter( (obj) => JSON.parse(obj.deliveryLine).id === deliveryId);  
            }
        }
        return [];
    }

    async function getDeliveryLinesData(config) {
        try {
            let res = {};
            let data = [];
            
            if(!config || (config && config.getPOHistoryListRestuarant) ) {

                res = await getPOHistoryListRestuarant({
                    token:auth.token,
                    state:JSON.stringify([2,8]),
                    businessId:0,
                    supplierId:auth.supplierId,
                    specialStartTime:'1900-01-01 00:00:00',
                    specialEndTime:'1900-01-01 00:00:00',
                    searchDateType:'delivery',
                    searchDate:moment(poSearchFields.searchDate).format('YYYY-MM-DD')
                });
    
                data = res.data.data;
    
                handleAPIResponse(res.data.result);
    
                if(data.length) {
                    setPOHistoryList(data);
                }

            }

            if(!config || (config && config.getDeliveryLinesQualityAssurance) ) {
                res = await getDeliveryLinesQualityAssurance({
                    token:auth.token,
                    supplierId:auth.supplierId,
                    storageDate:moment(poSearchFields.searchDate).format('YYYY-MM-DD')
                });
    
                data = res.data.data;
    
                handleAPIResponse(res.data.result);
    
                if(data.length) {
                    setDeliveryLinesQAList(data);
                }
            }

            setLoading(false);

        } catch (err) {
            handleServerErrorAPI(err);
        }
    }

    function getDeliveryLineBranchQA(branchId) {
        return deliveryLinesQAList.filter( (row) => {
            return row.BranchId === branchId
        })[0];
    }

    return (
        <ContainerComponent
            isLoading={loading}
            isServerError={serverError}
            isAuthError={authError}
            alertErrorMessage={alertErrorMessage}
            heading="Purchase Order Pending"
        >
            <Form onSubmit={handleOnSubmit}>
                <Row>
                    <Col className="mt-4 d-md-flex">
                        <div className="me-4">
                            <DateSingleComponent
                                label="Delivery Date"
                                startDate={moment(poSearchFields.searchDate)}
                                handleDateChange={handleDateSingleChange}
                                past={true}
                                isDayHighlightedData={supplierPurchaseOrderStorageDatesData}
                            />
                        </div>
                        {/*
                        <div className="me-4 align-self-end">
                            <Button 
                                disabled={searchIsDisabled()}
                                onClick={() => onClickSearch()}
                            >
                                Search
                            </Button>
                        </div>
                        */}
                    </Col>
                </Row>
                <Row>
                    <Col className="d-md-flex">
                        <div className="mt-4 me-4">
                            <FormDropDownComponent
                                formId="dropDownButtonDeliveryLine"
                                title="Select Delivery Line"
                                label="Delivery Line"
                                labelIcon={<Truck size={16} className="mb-1 me-1" />}
                                data={deliveryLineData}
                                onSelect={handleOnSelectDeliveryLine}
                                id={deliveryLineId}
                                variant="secondary"
                            />
                        </div>
                        {/*
                        <div className="me-4">
                            <FormDropDownComponent
                                formId="dropDownButtonBranch"
                                title="Select Branch"
                                label="Branch"
                                labelIcon={<Shop size={16} className="mb-1 me-1" />}
                                data={getBranchData()}
                                onSelect={handleOnSelectBranch}
                                id={branchId}
                                variant="secondary"
                            />
                        </div>
                        */}
                        <div className="mt-4 me-4">
                            <SearchListComponent 
                                placeholder="branch code or name"
                                label="Branch"
                                labelIcon={<Shop size={16} className="mb-1 me-1" />}
                                data={getBranchData()}
                                onClickBranch={handleOnSelectBranch}
                                activeListId={branchId}
                                />
                        </div>
                {/*        <div className="mt-4">
                            <FormDropDownComponent
                                formId="dropDownButtonOperator"
                                title="Select Operator"
                                label="Operator"
                                labelIcon={<Person size={16} className="mb-1 me-1" />}
                                data={operatorData}
                                onSelect={handleOnSelectOperator}
                                id={operatorId}
                                variant="secondary"
                            />
                    </div> */}
                    </Col>
                </Row>
            </Form>
            <Row>
                <Col className="mt-4">
                    <Tabs
                        defaultActiveKey="logisticsPickDelivery"
                        id="reports-tabs"
                        className="mb-3"
                    >
                        <Tab eventKey="logisticsPickDelivery" title="Pick and Delivery">
                            <Row>
                                <Col>
                                    {deliveryLineData.map( (row, index) => {
                                        if(deliveryLineId &&  deliveryLineId !== row.id) {
                                            return "";
                                        }

                                        if(row.id) {
                                            return (<TableLogisticsPickDelivery 
                                                deliveryLine={row.label}
                                                branches={getDeliveryLineBranches(row.id)}
                                                purchaseOrders={getDeliveryLinePurchaseOrders(row.id)}
                                                history={history}   
                                                key={row.id}
                                                onClickNoPurchaseOrders={handleClickNoPurchaseOrders}
                                                getDeliveryLineBranchQA={getDeliveryLineBranchQA}
                                            />)
                                        } else return "";
                                    })}
                                </Col>
                            </Row>
                        </Tab>
                        {/*
                        <Tab eventKey="purchaseOrders" title="Purchase Orders">
                            <Row>
                                <Col className="mt-4">
                                    <DateRangeCalendar
                                        startDate={startDate}
                                        endDate={endDate}
                                        handleDateChange={handleDateRangeChange}
                                        past={true}
                                        isDayHighlightedData={supplierPurchaseOrderStorageDatesData}
                                    />
                                </Col>
                                </Row>
                            <Row>
                                <Col className="mt-4">
                                    <AdvanceSettings />
                                    <TablePurchaseOrders 
                                        poHistoryList={poHistoryList}
                                    />
                                </Col>
                            </Row>
                        </Tab>
                        */}
                    </Tabs>
                </Col>
            </Row>
            {noResults &&
            <Row>
                <Col className="mt-4">
                    <NoResultsComponent />
                </Col>
            </Row>
            }
        </ContainerComponent>
    )
}  